import { render } from "./AdminUser.vue?vue&type=template&id=1992078d"
import script from "./AdminUser.vue?vue&type=script&lang=js"
export * from "./AdminUser.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__